<mat-nav-list>
  <div *ngFor="let link of linksArray()">
    <a mat-list-item *ngIf="link.show" (click)="closeDrawer()"
      [routerLink]="link.url">{{link.title}}</a>
  </div>
</mat-nav-list>